<script>
    export let icon = '';
    export let value = null;
    export let pulse = false;
    export let danger = false;
</script>


<div data-icon="{icon}" data-value="{value}" data-pulse="{pulse}" data-danger="{danger}">
    {#if value != null}
        <span style="height: {(value + 1) / 13 * 100}cqh"></span>
    {/if}
    <slot/>
</div>


<style lang="less">
    @import "./common.less";
    div {
        font-family: orbitron;
        font-size: 12px;
        position: relative;
        height: 100%;
        flex-direction: column;
        container-type: size;
    }
    div[data-icon="month"] {
        font-family: roboto;
        font-weight: bold;
    }
    div[data-danger="true"] {
        animation: insetRedPulse 1.8s infinite linear;
    }
    @keyframes insetRedPulse {
        0% {
            box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.7);
        } 50% {
            box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.0);
        } 100% {
            box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.7);
        }
    }
    div[data-pulse="true"] {
        animation: insetGlowPulse 1.8s infinite linear;
    }
    @keyframes insetGlowPulse {
        0% {
            box-shadow: inset 0 0 25px rgba(255, 255, 255, 0.7);
        } 50% {
            box-shadow: inset 0 0 25px rgba(255, 255, 255, 0.0);
        } 100% {
            box-shadow: inset 0 0 25px rgba(255, 255, 255, 0.7);
        }
    }
    .desktop({
        div[data-icon="health"], div[data-icon="impact"] {
            padding-bottom: 14px;
        }
        div[data-icon="health"] {
            color: @healthBarTextColor;
            background-color: @healthBarColor;
        }
        div[data-icon="impact"] {
            color: @impactBarTextColor;
            background-color: @impactBarColor;
        }
        div[data-icon="month"] {
            color: @monthBarTextColor;
            background-color: @monthBarColor;
        }
        div > span {
            background-color: @barBelowHighlightColor;
        }
        div > span::after {
            background-color: @barHighlightBackgroundColor;
        }
        span {
            display: block;
            position: absolute;
            bottom: 14px;
            width: 2.2em;
            left: 50%;
            transform: translateX(-50%);
            transition: height .9s 1.9s cubic-bezier(0.37, 0, 0.63, 1);
        };
        span::after {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            width: 100%;
            height: 7.9623cqh;
        }
        span, span::after {
            border-radius: 1.4em;
        }
        div {
            display: flex;
            flex: 1;
            flex-direction: column;
            margin: 20px 0;
            height: calc(100vh - 40px); box-sizing: border-box;
            border-radius: 4px;
            min-width: 77px;
        }
        div > :global(*) {
            transition: color .9s 1.9s cubic-bezier(0.37, 0, 0.63, 1);
        }
        div[data-icon="month"]::after {
            left: 0;
            right: auto;
        }
    });
    .mobile({
        div {
            display: flex;
            flex-direction: row;
        }
        span {
            display: none;
        }
    });
</style>